import { ReleaseState } from '../../../types/driver_types.ts';

import './release_state_pill.css';

interface ReleaseStateProps {
    releaseState: ReleaseState;
}

export const ReleaseStatePill = ({ releaseState }: ReleaseStateProps) => {
    switch (releaseState) {
        case 'ITL':
            return (
                <span className="release_state_pill release_state__internal">
                    internal
                </span>
            );
        case 'PRV':
            return (
                <span className="release_state_pill release_state__lead">
                    preview
                </span>
            );
        case 'PUB':
            return (
                <span className="release_state_pill release_state__public">
                    public
                </span>
            );
        case 'DPR':
            return (
                <span className="release_state_pill release_state__deprecated">
                    deprecated
                </span>
            );
        case 'MIXED':
            return (
                <span className="release_state_pill release_state__mixed">
                    mixed
                </span>
            );
        default:
            return <span className="release_state_pill">unknown</span>;
    }
};
